import React from 'react';

import { Datepicker as FlowbiteDatepicker } from 'flowbite-react';

export default function Datepicker({
  label,
  placeholder,
  name,
  value,
  onBlur,
  disabled,
  errors,
  touched,
  setFieldValue,
}) {
  return (
    <div>
      <label
        htmlFor={name}
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >
        {label}
      </label>
      <div className="relative">
        <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
          <svg
            aria-hidden="true"
            className="w-5 h-5 text-gray-500 dark:text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
              clipRule="evenodd"
            ></path>
          </svg>
        </div>

        <FlowbiteDatepicker
          disabled={disabled}
          value={value || null}
          onChange={(value) => setFieldValue(name, value)}
          name={name}
          buttons={false}
          onBlur={onBlur}
          placeholder={placeholder}
          showTodayButton={false}
          showClearButton={false}
          theme={{
            views: {
              days: {
                items: {
                  item: {
                    selected: 'bg-primary-700 text-white hover:bg-primary-600',
                  },
                },
              },
            },
          }}
        />
      </div>
      {errors && touched && (
        <div className="text-red-500 text-sm mt-1">{errors}</div>
      )}
    </div>
  );
}
